<template>
  <div>
     {{msg}}
  </div>
</template>

<script>
    export default {
    name: 'errorpage',
    props: [],
    components:{},
    data:function(){
    return{
        msg:"无权限访问"
    }
    },
    setup(){
    
    },
    mounted:function(){
    },
    methods:{}    
    }
</script>


<style>

</style>